// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Int from "bs-platform/lib/es6/belt_Int.js";
import * as Belt_Float from "bs-platform/lib/es6/belt_Float.js";
import * as Button$Xuder from "./Button.bs.js";
import * as Events$Xuder from "../utils/Events.bs.js";
import * as Dropdown$Xuder from "./Dropdown.bs.js";
import * as TextInput$Xuder from "./TextInput.bs.js";

var currencies = /* array */[
  /* tuple */[
    "USD",
    "USD"
  ],
  /* tuple */[
    "GBP",
    "GBP"
  ],
  /* tuple */[
    "EUR",
    "EUR"
  ],
  /* tuple */[
    "ZAR",
    "ZAR"
  ],
  /* tuple */[
    "KYD",
    "KYD"
  ],
  /* tuple */[
    "CHF",
    "CHF"
  ]
];

function stringToCurrency(str) {
  switch (str) {
    case "CHF" :
        return /* CHF */5;
    case "EUR" :
        return /* EUR */2;
    case "GBP" :
        return /* GBP */1;
    case "KYD" :
        return /* KYD */4;
    case "USD" :
        return /* USD */0;
    case "ZAR" :
        return /* ZAR */3;
    default:
      return /* USD */0;
  }
}

function ZcbForm(Props) {
  var onDrawImage = Props.onDrawImage;
  var match = React.useReducer((function (param, v) {
          return v;
        }), 1);
  var setTime = match[1];
  var time = match[0];
  var match$1 = React.useReducer((function (param, v) {
          return v;
        }), /* USD */0);
  var setCurrency = match$1[1];
  var currency = match$1[0];
  var match$2 = React.useReducer((function (param, v) {
          return v;
        }), "10.0");
  var setValue = match$2[1];
  var value = match$2[0];
  return React.createElement(React.Fragment, undefined, React.createElement("label", {
                  className: "compose-label"
                }, React.createElement("h5", undefined, "Horizon"), React.createElement(TextInput$Xuder.make, {
                      value: String(time),
                      type_: "number",
                      onChange: (function (e) {
                          var match = Belt_Int.fromString(Events$Xuder.targetValue(e));
                          return Curry._1(setTime, match !== undefined ? match : 0);
                        }),
                      name: "horizon"
                    })), React.createElement("label", {
                  className: "compose-label"
                }, React.createElement("h5", undefined, "Value"), React.createElement(TextInput$Xuder.make, {
                      value: value,
                      onChange: (function (e) {
                          return Curry._1(setValue, Events$Xuder.targetValue(e));
                        }),
                      name: "Value"
                    })), React.createElement("label", {
                  className: "compose-label"
                }, React.createElement("h5", undefined, "Currency"), React.createElement(Dropdown$Xuder.make, {
                      values: currencies,
                      showFirst: true,
                      onChange: (function (e) {
                          return Curry._1(setCurrency, stringToCurrency(Events$Xuder.targetValue(e)));
                        }),
                      name: "currency"
                    })), React.createElement(Button$Xuder.make, {
                  children: "Draw & Save",
                  onClick: (function (_e) {
                      var match = Belt_Float.fromString(value);
                      if (match !== undefined) {
                        return Curry._1(onDrawImage, /* ZCB */Block.__(0, [
                                      /* time */time,
                                      /* value */match,
                                      /* currency */currency
                                    ]));
                      } else {
                        return /* () */0;
                      }
                    })
                }));
}

var make = ZcbForm;

export {
  currencies ,
  stringToCurrency ,
  make ,
  
}
/* react Not a pure module */
